import { useLocation } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { routesHandler } from 'Checkout/Routes/routesHandler'
import ReservationDetailItem from 'Shared/ReservationDetailItem'
import TaxDetails from 'Shared/TaxDetails'

const ExtraPricingFields = () => {
  const { pathname } = useLocation()
  const marketplace = useSelector(state => state.campground.marketplace.isMarketplace)
  const pricing = useSelector(state => state.cart.pricing.data)
  const { isTripProtection, tripProtectionQuote } = useSelector(state => state.payment)
  const { dueNow, dueAtCheckIn, isTaxIncluded, platformFeeTotal, processingFeeTotal, taxName, taxTotal,
          total: camperTotal } = pricing || {}
  const feeLabel = marketplace ? 'Service Fee' : 'Platform Fee'
  const isPaymentPage = routesHandler.payment.path === pathname
  const itemNameClass = 'fw-normal not-all-block-loading'

  return (
    <div className="pricing-fields">
      {!isTaxIncluded && (
        <ReservationDetailItem hideColon itemName="Tax" itemNameClass={itemNameClass} value={taxTotal} />
      )}

      {processingFeeTotal?.amount > 0 && (
        <ReservationDetailItem hideColon itemName="Processing Fee" itemNameClass={itemNameClass}
                               value={processingFeeTotal} />
      )}

      <ReservationDetailItem hideColon itemName={feeLabel} itemNameClass={itemNameClass}
                             value={platformFeeTotal?.display} />

      {isTripProtection && tripProtectionQuote && (
        <ReservationDetailItem hideColon itemName="Trip Protection" itemNameClass={itemNameClass}
                               value={tripProtectionQuote} />
      )}

      <ReservationDetailItem containerClass="mt-3" hideColon itemName="Total"
                             itemNameClass="col-6 align-text-bottom not-all-block-loading"
                             value={camperTotal?.displayWithCode} valueClass="fw-bold text-green pe-0 text-end" />

      {isPaymentPage && (
        <>
          <hr />

          <ReservationDetailItem containerClass="mt-4" hideColon itemName="Due Now"
                                 itemNameClass={itemNameClass} value={dueNow?.display} />

          {dueAtCheckIn?.amount > 0 && (
            <ReservationDetailItem hideColon itemName="Remaining Balance" itemNameClass={itemNameClass}
                                  value={dueAtCheckIn?.display} />
          )}

          {isTaxIncluded && (
            <TaxDetails nameClass={itemNameClass} tax={taxTotal} taxName={taxName} valueClass="text-gray-800" />
          )}
        </>
      )}
    </div>
  )
}

export default ExtraPricingFields
